// Imports

import React from 'react';
import { withRouter } from 'react-router';

// Scroll To Top On Page Change

class ScrollToTopOnPageChange extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTopOnPageChange);
